<template>
  <div>
    <b-breadcrumb class="d-info">
      <b-breadcrumb-item to="/">首頁</b-breadcrumb-item>
      <b-breadcrumb-item to="/deliver">訂單查詢</b-breadcrumb-item>
      <b-breadcrumb-item active>訂單明細</b-breadcrumb-item>
    </b-breadcrumb>
    <h4 class="text-center p-2 mt-4">
      <span class="mark-bottom">訂單明細</span>
    </h4>
    <b-container class="border">
      <b-row class="p-3">
        <b-col cols="12" class="mt-3">
          <h5 class="text-info">• 訂單資訊</h5>
          <b-row class="p-1 h6 outline-light-grey" no-gutters>
            <b-col cols="2" class="text-right bg-grey p-1 pr-2">
              <strong>訂單編號</strong>
            </b-col>
            <b-col cols="10" class="p-1 pl-4">{{uqid}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>訂單狀態</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{state}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>訂購日期</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{time}}</b-col>
          </b-row>
        </b-col>
        <b-col cols="12" class="mt-3">
          <h5 class="text-info">• 訂購商品</h5>
          <b-table :fields="fields" :items="items" outlined border responsive head-variant="light"></b-table>
          <b-row class="p-1 h6 outline-light-grey" no-gutters>
            <b-col cols="2" class="text-right bg-grey p-1 pr-2">
              <strong>商品件數</strong>
            </b-col>
            <b-col cols="10" class="p-1 pl-4">{{counter}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>商品總計</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">${{sum}}</b-col>
          </b-row>
        </b-col>
        <b-col cols="12" class="mt-3">
          <h5 class="text-info">• 付款資訊</h5>
          <b-row class="p-1 h6 outline-light-grey" no-gutters>
            <b-col cols="2" class="text-right bg-grey p-1 pr-2">
              <strong>付款方式</strong>
            </b-col>
            <b-col cols="10" class="p-1 pl-4">ATM轉帳</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>付款金額</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">$300</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>付款截止時間</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">2019-12-17 16:50:01</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>付款銀行代號</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4"><strong>001</strong></b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>付款帳號</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4"><strong>95175369852147</strong></b-col>
          </b-row>
        </b-col>
        <b-col md="6" cols="12" class="mt-3">
          <h5 class="text-info">• 購買人資訊</h5>
          <b-row class="p-1 h6 outline-light-grey" no-gutters>
            <b-col cols="2" class="text-right bg-grey p-1 pr-2">
              <strong>姓名</strong>
            </b-col>
            <b-col cols="10" class="p-1 pl-4">{{buyer.name}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>學號</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{buyer.school_num}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>電話</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{buyer.tel}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>Email</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{buyer.email}}</b-col>
          </b-row>
        </b-col>
        <b-col md="6" cols="12" class="mt-3">
          <h5 class="text-info">• 取貨人資訊</h5>
          <b-row class="p-1 h6 outline-light-grey" no-gutters>
            <b-col cols="2" class="text-right bg-grey p-1 pr-2">
              <strong>姓名</strong>
            </b-col>
            <b-col cols="10" class="p-1 pl-4">{{receiver.name}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>學號</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{receiver.school_num}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>電話</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{receiver.tel}}</b-col>
            <b-col cols="2" class="text-right bg-grey mt-1 p-1 pr-2">
              <strong>Email</strong>
            </b-col>
            <b-col cols="10" class="mt-1 p-1 pl-4">{{receiver.email}}</b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from 'moment'
import { DeliverStates } from '../library/Var.js'
export default {
  data () {
    return {
      buyer: {
        name: '',
        tel: '',
        email: '',
        school_num: ''
      },
      receiver: {
        name: '',
        tel: '',
        email: '',
        school_num: ''
      },
      items: [],
      sum: 0,
      counter: 0,
      uqid: '',
      state: '',
      time: null
    }
  },
  computed: {
    fields () {
      return [
        { key: 'name', label: '商品', thClass: 'w-50' },
        { key: 'size', label: '規格' },
        { key: 'price', label: '單價' },
        { key: 'amount', label: '數量' },
        { key: 'total', label: '小計' }
      ]
    },
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    async fetch () {
      const { data } = await this.$api.getMyDelDetail(this.id)
      const { uqid, state, time, receiver_info, ref_user } = data
      this.buyer = ref_user
      this.receiver = receiver_info
      const { content } = data
      let sum = 0
      let counter = 0
      this.items = content.map(item => {
        const { amount, ref_catalog: catalog } = item
        const { name, price } = catalog
        const size = catalog.size.find(s => s._id === item.ref_size)
        const total = price * amount
        sum += total
        counter += amount
        return {
          name, size: size.name, price, amount, total
        }
      })
      this.sum = sum
      this.counter = counter
      this.state = DeliverStates[state] || '未知'
      this.time = moment(time).format('YYYY/MM/DD')
      this.uqid = uqid
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>
<style scoepd>
  .breadcrumb.d-info {
	background: none;
    margin-bottom: 0;
    padding-left: 20%;
  }
  .bg-grey {
    background-color: #e9ecef;
  }
  .outline-light-grey {
    border: 1px solid #f2f2f2;
  }
  div.col-10.p-1 {
	background: #f5f7f8;
    border-left: 2px solid #fff;
  }
  @media (max-width: 1870px) {
  .breadcrumb.d-info {
    padding-left: 8%;
  }}
  .text-info {
    color: #5364b5!important;
  }
</style>